module.exports = __webpack_public_path__ + "static/media/dash-style-icon.dba7ede2.svg";